export default __webpack_public_path__ + "static/media/Form.21b8d013.JPG";